import { Option, TranslationFunction } from '@/types';

export const columns = ($t: TranslationFunction): Option[] => [
  {
    value: 'alarmType',
    label: $t('causeOfAlarmUpperCase')
  },
  {
    value: 'timestamp',
    label: $t('startTimeUpperCase')
  },
  {
    value: 'alarmEndTimestamp',
    label: $t('endTimeUpperCase')
  },
  {
    value: 'duration',
    label: $t('durationUpperCase')
  },
  {
    value: 'alarmMax',
    label: $t('maxUpperCase')
  },
  {
    value: 'alarmMin',
    label: $t('minUpperCase')
  },
  {
    value: 'sensor',
    label: $t('sensorUpperCase')
  },
  {
    value: 'averageTemp',
    label: $t('averageUpperCase')
  },
  {
    value: 'alarmComment',
    label: $t('alarmCommentUpperCase')
  }
];

// Values match the `alarmType` field returned for each alarm; `all` is the
// default and keeps the list unfiltered.
export const alarmCauseOptions = ($t: TranslationFunction): Option[] => [
  {
    value: 'all',
    label: $t('allAlarms')
  },
  {
    value: 'ok',
    label: $t('alarmOk')
  },
  {
    value: 'door_open',
    label: $t('alarmDoorOpen')
  },
  {
    value: 'door_closed',
    label: $t('alarmDoorClosed')
  },
  {
    value: 'temp_high',
    label: $t('alarmTempHigh')
  },
  {
    value: 'temp_low',
    label: $t('alarmTempLow')
  },
  {
    value: 'other',
    label: $t('alarmOther')
  },
  {
    value: 'missing',
    label: $t('alarmMissing')
  }
];
